document.addEventListener('DOMContentLoaded', function() {
    const preloader = document.querySelector('.tptai-preloader---logo');
    
    if (!preloader) return;
    
    // Get settings from the preloader element
    const showOnce = preloader.dataset.showOnce === 'true';
    const preloaderKey = preloader.dataset.preloaderKey || 'default';
    const totalDuration = parseInt(preloader.dataset.totalDuration) || 4000; // Default 4 seconds
    
    // Storage key for tracking preloader display (unique per section)
    const PRELOADER_STORAGE_KEY = `tptai_preloader_shown_${preloaderKey}`;
    
    // Get timing values from CSS custom properties
    const computedStyle = getComputedStyle(preloader);
    const fadeInDuration = parseFloat(computedStyle.getPropertyValue('--fade-in-duration')) || 1.5;
    const holdDuration = parseFloat(computedStyle.getPropertyValue('--hold-duration')) || 1;
    const fadeOutDuration = parseFloat(computedStyle.getPropertyValue('--fade-out-duration')) || 1.5;
    
    // Additional fade out duration for manual hide
    const manualFadeOutDuration = 500;
    
    // Check if preloader has been shown before
    function hasPreloaderBeenShown() {
        if (!showOnce) return false; // Always show if not set to show once
        
        try {
            return localStorage.getItem(PRELOADER_STORAGE_KEY) === 'true';
        } catch (e) {
            // If localStorage is not available (e.g., private browsing), 
            // fall back to sessionStorage or always show
            try {
                return sessionStorage.getItem(PRELOADER_STORAGE_KEY) === 'true';
            } catch (e) {
                return false; // Always show if no storage available
            }
        }
    }
    
    // Mark preloader as shown
    function markPreloaderAsShown() {
        if (!showOnce) return; // Don't store if not set to show once
        
        try {
            localStorage.setItem(PRELOADER_STORAGE_KEY, 'true');
        } catch (e) {
            // Fallback to sessionStorage if localStorage fails
            try {
                sessionStorage.setItem(PRELOADER_STORAGE_KEY, 'true');
            } catch (e) {
                // If both fail, continue without storage
                console.warn('Storage not available for preloader state');
            }
        }
    }
    
    // Function to hide preloader immediately
    function hidePreloaderImmediate() {
        preloader.style.display = 'none';
        document.body.style.overflow = 'auto';
        document.body.style.position = '';
    }
    
    // Check if preloader should be shown
    if (hasPreloaderBeenShown()) {
        // Preloader has been shown before, hide it immediately
        hidePreloaderImmediate();
        return;
    }
    
    // If we reach here, show the preloader for the first time
    // Show preloader initially and prevent scrolling
    preloader.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    
    // Mark as shown in storage (do this early to prevent multiple displays)
    markPreloaderAsShown();
    
    // Function to hide preloader with animation
    function hidePreloader() {
        preloader.classList.add('animation-complete');
        setTimeout(() => {
            preloader.style.display = 'none';
            document.body.style.overflow = 'auto';
            document.body.style.position = '';
            document.body.style.width = '';
        }, manualFadeOutDuration);
    }
    
    // Function to hide preloader immediately (for manual interaction)
    function hidePreloaderManual() {
        preloader.classList.add('fade-out');
        setTimeout(() => {
            preloader.style.display = 'none';
            document.body.style.overflow = 'auto';
            document.body.style.position = '';
            document.body.style.width = '';
        }, manualFadeOutDuration);
    }
    
    // Auto hide after animation completes
    setTimeout(() => {
        hidePreloader();
    }, totalDuration);
    
    // Optional: Hide on click/tap (for user interaction)
    preloader.addEventListener('click', function(e) {
        // Prevent accidental clicks on the logo itself
        if (e.target.closest('.tptai-preloader---logo_container')) {
            return;
        }
        
        // Stop the current animation and fade out immediately
        hidePreloaderManual();
    });
    
    // Hide on escape key press
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && preloader.style.display === 'flex') {
            hidePreloaderManual();
        }
    });
    
    // Handle page visibility changes
    document.addEventListener('visibilitychange', function() {
        const container = preloader.querySelector('.tptai-preloader---logo_container');
        if (document.hidden) {
            // Page is hidden, pause animations if needed
            if (container) {
                container.style.animationPlayState = 'paused';
            }
        } else {
            // Page is visible, resume animations
            if (container) {
                container.style.animationPlayState = 'running';
            }
        }
    });
    
    // Listen for animation end event
    const container = preloader.querySelector('.tptai-preloader---logo_container');
    if (container) {
        container.addEventListener('animationend', function(e) {
            // The animation name will be like 'preloader-[section-id]'
            if (e.animationName.startsWith('preloader-')) {
                hidePreloader();
            }
        });
    }
    
    // Prevent scrolling issues on mobile
    function preventScroll(e) {
        e.preventDefault();
    }
    
    // Add touch event listeners to prevent scrolling
    preloader.addEventListener('touchmove', preventScroll, { passive: false });
    preloader.addEventListener('touchstart', preventScroll, { passive: false });
    
    // Debug logging (can be removed in production)
    if (typeof console !== 'undefined' && console.log) {
        console.log('Preloader initialized with timing:', {
            fadeIn: fadeInDuration + 's',
            hold: holdDuration + 's',
            fadeOut: fadeOutDuration + 's',
            total: (totalDuration / 1000) + 's'
        });
    }
});

// Utility function to reset preloader state (for development/testing)
// Call this from browser console: resetPreloaderState()
function resetPreloaderState(sectionId = null) {
    try {
        if (sectionId) {
            // Reset specific section preloader
            const key = `tptai_preloader_shown_${sectionId}`;
            localStorage.removeItem(key);
            sessionStorage.removeItem(key);
            console.log(`Preloader state reset for section ${sectionId}. Refresh the page to see preloader again.`);
        } else {
            // Reset all preloader states
            const keys = Object.keys(localStorage).filter(key => key.startsWith('tptai_preloader_shown_'));
            keys.forEach(key => {
                localStorage.removeItem(key);
                sessionStorage.removeItem(key);
            });
            
            // Also clear sessionStorage
            const sessionKeys = Object.keys(sessionStorage).filter(key => key.startsWith('tptai_preloader_shown_'));
            sessionKeys.forEach(key => {
                sessionStorage.removeItem(key);
            });
            
            console.log('All preloader states reset. Refresh the page to see preloaders again.');
        }
    } catch (e) {
        console.warn('Could not reset preloader state:', e);
    }
}

// Utility function to manually trigger preloader (for testing)
function triggerPreloader(sectionId = null) {
    if (sectionId) {
        resetPreloaderState(sectionId);
    } else {
        resetPreloaderState();
    }
    window.location.reload();
}